import i18n from '@/i18n';
import { infringementAPI } from '@/utils/api';
import { sleepVisibilityAware } from '@/utils/pageVisibility';
import { logImageProcess } from './ipeImageProcessLog';

/** Phase 1 起 createBatch 仅写库即返，完成态以批次 status 或全部 item 终态为准 */
export function isInfringementBatchFinished(detail) {
  const st = String(detail?.status || '').toLowerCase();
  if (st === 'completed' || st === 'partial' || st === 'failed') {
    return true;
  }
  const items = Array.isArray(detail?.items) ? detail.items : [];
  if (items.length === 0) {
    return false;
  }
  return items.every((it) => {
    const itemStatus = String(it?.itemStatus || '').toLowerCase();
    return itemStatus === 'success' || itemStatus === 'failed';
  });
}

/**
 * 轮询侵权检测批次直至完成（工作流 / 商品上架等调用方共用）。
 * @param {number|string} batchId
 * @param {{ maxAttempts?: number, intervalMs?: number, timeoutMessage?: string }} [options]
 */
export async function pollInfringementBatch(
  batchId,
  { maxAttempts = 90, intervalMs = 2000, timeoutMessage } = {},
) {
  const id = Number(batchId);
  if (!id) throw new Error(i18n.t('workbench:ipeUtilError.invalidInfringementBatch'));
  logImageProcess('detection', 'poll_start', { batchId: id, maxAttempts, intervalMs });
  for (let i = 0; i < maxAttempts; i += 1) {
    const detail = await infringementAPI.getBatch(id);
    const items = Array.isArray(detail?.items) ? detail.items : [];
    const doneCount = items.filter((it) => {
      const itemStatus = String(it?.itemStatus || '').toLowerCase();
      return itemStatus === 'success' || itemStatus === 'failed';
    }).length;
    if (i === 0 || isInfringementBatchFinished(detail) || (i + 1) % 5 === 0) {
      logImageProcess('detection', 'poll_tick', {
        batchId: id,
        attempt: i + 1,
        status: detail?.status,
        doneCount,
        total: items.length,
      });
    }
    if (isInfringementBatchFinished(detail)) {
      logImageProcess('detection', 'done', { batchId: id, status: detail?.status, doneCount, total: items.length });
      return detail;
    }
    await sleepVisibilityAware(intervalMs);
  }
  logImageProcess('detection', 'failed', { batchId: id, message: i18n.t('workbench:ipeUtilError.infringementTimeout') });
  throw new Error(
    timeoutMessage || i18n.t('workbench:ipeUtilError.infringementTimeoutViewPage'),
  );
}
